export interface EditorPanelState {
	fullscreenPanelId: string | null;
}

export enum EditorPanelMutation {
	FULLSCREEN_PANEL_ID = 'FULLSCREEN_PANEL_ID',
}

export const EditorPanelStateModule = {
	namespaced: true,
	state(): EditorPanelState {
		return {
			fullscreenPanelId: null,
		};
	},

	mutations: {
		[EditorPanelMutation.FULLSCREEN_PANEL_ID]: (state: EditorPanelState, payload: string) => {
			state.fullscreenPanelId = payload;
		},
	},
};
